import { FC, useEffect, useState } from 'react'
import { Form, json, replace, useActionData } from 'react-router-dom'

// COMPONENTS
import Button from '@components/atoms/button'
import TextField from '@components/atoms/textfield'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { createAction } from '@utils/actions'
import { isFailedResponse } from '@apis'
import { isNonEmptyString } from '@utils/type-checkers'
import { formatInput, normalizeInput } from '@utils/phone-number-helper'
import { useProfilePhoneContext } from '..'
import { useInput } from '@hooks/inputs'
import { createAuthenticatedLoader } from '@utils/loaders'


const placeholder = formatInput('(555)555-5555')
const maxPhoneLength = placeholder.length

const Component: FC<{}> = () => {
    const data = useActionData()
    const { setToast } = useProfilePhoneContext()

    const countryCodeProps = useState('+1')[1]
    const [phoneNumber, phoneNumberProps] = useInput({
        onChange: (v) => formatInput(v, phoneNumber)
    })

    useEffect(() => {
        console.log(data)
        if (data != null) setToast({ type: 'error', text: isNonEmptyString(data) ? data : 'An unexpected Error occured' });
    }, [setToast, data])

    return (
        <Form className="flex flex-col" style={{ gap: 'inherit' }} method="POST">
            <h4>Change Phone Number</h4>
            <input {...countryCodeProps} name="country-code" hidden />
            <TextField {...phoneNumberProps} type="tel" autoComplete="tel-national" name="phone-number" maxLength={maxPhoneLength} placeholder="Phone Number" required />
            <Button type="submit" theme="primary">Continue</Button>
        </Form>
    )
}

const loader = createAuthenticatedLoader(async (_, Clerk) => {
    const hasPrimary = !!Clerk.user?.primaryPhoneNumber
    if (!hasPrimary) return json(null, 200)
    else return replace('/account/profile')
})

const action = createAction(async ({ request }) => {
    try {
        const data = await request.formData()
        const user = window.Clerk?.user
        const countryCode = `${data.get('country-code')}`
        const phoneNumber = `${countryCode}${normalizeInput(`${data.get('phone-number')}`)}`
        if (!user) throw new Error(`Unauthenticated`)

        const resource = await user.createPhoneNumber({ phoneNumber })
        return replace(`/account/profile/phone/${resource.id}/verify`)
    } catch (error) {
        console.error(error)
        if (isFailedResponse(error) || error instanceof Error) return json(error.message);
        else return json('An unexpected Error occured')
    }
})

const AddPhoneRoute: RouteObject = {
    index: true,
    Component,
    loader,
    action,
}

export { AddPhoneRoute } 